<div class="container">
  <div class="header">
    <button mat-raised-button 
          color="primary" 
          class="dashboard-button" 
          routerLink="/sales/generaldash">
    <mat-icon>dashboard</mat-icon>
    <span>Sales Dashboard</span>
    </button>
    <h1 class="page-title" >Last 7 Days View</h1>
</div>

  <div style="background-color: lightcyan;">
    <span><strong>Combined Daily Sales</strong></span>
    <br/>
    <form [formGroup]="dateForm">
      <input  name="getDate" matInput formControlName="getDate" /> <span><strong>&nbsp; (DD/MM/YYYY) &nbsp;</strong></span>
      <button style="float: none;" type="button" mat-raised-button (click)="getDay()" color="warn">Get Sales</button>
    </form>

    <!-- <div class="chart-container">
      <ngx-charts-bar-vertical-2d
        *ngIf="!isLoading && salesData.length > 0"
        [view]="view"
        [scheme]="colorScheme"
        [results]="salesData"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
        [yAxisTickFormatting]="formatCurrency">
      </ngx-charts-bar-vertical-2d>
  
      <mat-spinner *ngIf="isLoading" diameter="50" class="loading-spinner"></mat-spinner>
    </div> -->
    
    <kendo-grid
      [data]="gridDataCurrentDay"
      [height]="215"
      [pageSize]="gridStateDay.take"
      [skip]="gridStateDay.skip"
      [pageable]="false"
      [sortable]="false"
      (dataStateChange)="dataStateChange($event)"
    >
      <kendo-grid-column field="date" title="Date">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: left'>
            Combined Sales:
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="store" title="Store"></kendo-grid-column>
      <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalDayOfWeek["netSales"].sum.toFixed(2) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalDayOfWeek["totalSales"].sum.toFixed(2) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>         
      <kendo-grid-column field="totalSales" title="Total Dine-In" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
        <strong>{{ (dataItem.cashSales + dataItem.cardSales) | number : '1.2-2' }}</strong>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="totalSales" title="Dine-In %" [sortable]="false" format="##,###.##">
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
        <strong>{{ (dataItem.cashSales + dataItem.cardSales) / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalDayOfWeek["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="deliverySales" title="Delivery %" [sortable]="false" format="##,###.##">
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
        <strong>{{ dataItem.deliverySales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalDayOfWeek["transactions"].sum.toFixed(0) }}
          </span>
        </ng-template> 
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <br/>

  <span><strong>Creams Weekly Sales</strong></span>
  <br/>
  
  <kendo-grid
    [data]="gridDataCurrentWeekCreams"
    [height]="215"
    [pageSize]="gridStateWeekCreams.take"
    [skip]="gridStateWeekCreams.skip"
    [pageable]="false"
    [sortable]="false"
    (dataStateChange)="dataStateChange($event)"
  >
    <kendo-grid-column field="date" title="Date">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: left'>
          Combined Sales:
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="dayOfWeek" title="Day"></kendo-grid-column>
    <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekCreams["netSales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>
    <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekCreams["totalSales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>     
    <kendo-grid-column field="totalSales" title="VAT" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.totalSales - dataItem.netSales) | number : '1.2-2' }}</strong>
      </ng-template>
    </kendo-grid-column>     
    <kendo-grid-column field="totalSales" title="Total Dine-In" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.cashSales + dataItem.cardSales) | number : '1.2-2' }}</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="totalSales" title="Dine-In %" [sortable]="false" format="##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.cashSales + dataItem.cardSales) / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekCreams["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>
    <kendo-grid-column field="deliverySales" title="Delivery %" [sortable]="false" format="##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ dataItem.deliverySales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekCreams["transactions"].sum.toFixed(0) }}
        </span>
      </ng-template> 
    </kendo-grid-column>
  </kendo-grid>
  <br/>

  <span><strong>MH Weekly Sales</strong></span>
  <br/>
  
  <kendo-grid
    [data]="gridDataCurrentWeekMH"
    [height]="215"
    [pageSize]="gridStateWeekMH.take"
    [skip]="gridStateWeekMH.skip"
    [pageable]="false"
    [sortable]="false"
    (dataStateChange)="dataStateChange($event)"
  >
    <kendo-grid-column field="date" title="Date">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: left'>
          Combined Sales:
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="dayOfWeek" title="Day"></kendo-grid-column>
    <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekMH["netSales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>
    <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekMH["totalSales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>    
    <kendo-grid-column field="totalSales" title="VAT" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.totalSales - dataItem.netSales) | number : '1.2-2' }}</strong>
      </ng-template>
    </kendo-grid-column>       
    <kendo-grid-column field="totalSales" title="Total Dine-In" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.cashSales + dataItem.cardSales) | number : '1.2-2' }}</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="totalSales" title="Dine-In %" [sortable]="false" format="##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ (dataItem.cashSales + dataItem.cardSales) / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekMH["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
        </span>
      </ng-template> 
    </kendo-grid-column>
    <kendo-grid-column field="deliverySales" title="Delivery %" [sortable]="false" format="##,###.##">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
      >
      <strong>{{ dataItem.deliverySales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
      <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
        <span style='float: right'>
          {{ totalDayOfWeekMH["transactions"].sum.toFixed(0) }}
        </span>
      </ng-template> 
    </kendo-grid-column>
  </kendo-grid>

</div> 